export default __webpack_public_path__ + "static/media/container_transversal.b73c46db.svg";